<template>
    <div :class="{ 'card-no-border': groupByApp }" class="card" @click="click" role="button">
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-12 col-md-3 text-truncate" v-if="withApplication">
                    <a href="javascript:void(0)">
                        {{ this.showValue ? application.name : '' }}
                    </a>
                </div>
                <div class="col-12 col-md-4 text-truncate" v-if="withUser">
                    <a href="javascript:void(0)">
                        {{ user.first_name }} {{ user.last_name }}
                    </a>
                </div>
                <div class="col-12 col-md-3 text-truncate" v-if="$root.features?.profiles?.application_username">
                    <FormattedValue v-if="showValue" :value="profile.username" />
                </div>
                <div class="col-10 text-truncate"
                    :class="{ 'col-md-3': !!$root.features?.profiles?.application_username, 'col-md-6': !$root.features?.profiles?.application_username }">
                    <a href="javascript:void(0)">
                        <UserProfileBadge :profile="profile" />
                        <Tooltip :title="i18n('Pending approval')" v-if="profile.is_pending_approval">
                            <PendingApprovalIcon />
                        </Tooltip>
                        {{ profile.name }}
                    </a>
                </div>
                <div class="col-2 text-end" @click.stop v-if="!hideActions">
                    <ActionDropdown :actions="actions" />
                </div>
            </div>
        </div>
    </div>
    <UserProfileModal :user="user" ref="UserProfileModal" />
</template>

<script>
import api from "@/api.js";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import DangerModal from "@/components/common/confirm/DangerModal.vue";
import FormattedValue from "@/components/common/form/FormattedValue.vue";
import UserProfileModal from "@/components/userProfile/UserProfileModal.vue";
import UserProfileBadge from "@/components/userProfile/UserProfileBadge.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";
import PendingApprovalIcon from "@/assets/svg/pending-approval.vue";

export default {
    components: {
        ActionDropdown,
        DangerModal,
        FormattedValue,
        UserProfileModal,
        UserProfileBadge,
        Tooltip,
        PendingApprovalIcon,
    },
    emits: [
        'updated',
        'editUsername',
        'approveProfile',
    ],
    props: {
        withUser: {
            type: Boolean,
            default: false,
        },
        withApplication: {
            type: Boolean,
            default: true,
        },
        application: {
            type: Object,
            default() {
                return {};
            },
        },
        user: {
            type: Object,
            default() {
                return {};
            },
        },
        profile: {
            type: Object,
            default() {
                return {};
            },
        },
        hideActions: {
            type: Boolean,
            default: false,
        },
        expiresAt: {
            type: String,
            default: null,
        },
        isPendingApproved: {
            type: Boolean,
            default: false,
        },
        groupByApp: {
            type: Boolean,
            default: false,
        },
        showValue: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        click() { },
        remove() {
            this.$root.setSaving(true);
            api.delete(`users/${this.user.id}/profiles/${this.profile.id}`).then(() => {
                this.$root.setSaved(true);
                this.$root.setLoading(false);
                let index = (this.user.profiles || []).map(e => e.id).indexOf(
                    this.profile.id);

                if (index !== -1) {
                    this.user.profiles.splice(index, 1);
                }

                this.$emit('updated');
            }).catch((err) => {
                console.error('Error deleting profile:', err);
            }).finally(() => {
                this.$root.setSaved(true);
                this.$root.setLoading(false);
            });
        },
        approve() {
            this.$root.setSaving(true);
            api.post(`users/${this.user.id}/profiles/${this.profile.id}/approve`).then(() => {
                this.$root.setSaved(true);
                this.$root.setLoading(false);
                this.$emit('updated');
            }).catch((err) => {
                console.error('Error approving profile:', err);
            }).finally(() => {
                this.$root.setSaved(true);
                this.$root.setLoading(false);
            });
        },

    },
    computed: {
        actions() {
            return [{
                label: this.i18n('Update User Application Username'),
                fn: () => {
                    this.$emit('editUsername', { user: { id: this.user.id }, profile: { application: { id: this.application.id } } });
                },
                if: (this.user?.acl?.update) === true && (!this.application?.is_self && this.application?.is_identity) && this.$root.features?.profiles?.application_username,
                starred: false,
            }, {
                label: this.i18n('Approve profile'),
                fn: () => {
                    this.$root.requestConfirmation(this.i18n('Approve profile?'), () => {
                        this.approve();
                    });
                },
                if: this.profile.is_pending_approval == 1 && this.profile.can_be_approved === true,
            },
            {
                label: this.i18n('Remove'),
                fn: () => {
                    this.$root.requestConfirmation(this.i18n('Remove?'), () => {
                        this.remove();
                    });
                },
                if: this.user?.acl?.update === true,
            }];
        },
    },
};
</script>
<style scoped>
.card-no-border {
    border: none !important;
}
</style>